module.exports = __webpack_public_path__ + "media/images/emblems/Collonges_VS-coat_of_arms-352ea5e53b90d1b612b64f4a8e957c12.svg";